module.exports = __webpack_public_path__ + "6f3587aae3df6422b710dd0508730b1e.MP3";